<app-header-style-two></app-header-style-two>

<div class="page-title-area item-bg1">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/">Accueil</a></li>
                <li>Erreur</li>
            </ul>
            <h2>Page introuvable</h2>
        </div>
    </div>
</div>

<div class="error-404-area">
    <div class="container">
        <div class="notfound">
            <div class="notfound-bg">
                <div></div>
                <div></div>
                <div></div>
            </div>
            <h1>Oops!</h1>
            <h3>Erreur : Page introuvable</h3>
            <p>La page que vous demandez est temporairement indisponible, elle sera bientôt disponible. Merci.</p>
            <a routerLink="/" class="default-btn"><i class='bx bx-home-circle icon-arrow before'></i><span class="label">Accueil</span><i class="bx bx-home-circle icon-arrow after"></i></a>
        </div>
    </div>
</div>